import React from "react";

import ListSubheader from "@mui/material/ListSubheader";

import {
    SidebarObjectListItem,
    SidebarObjectSortableListItem
} from "./SidebarObjectListItem";

class ObjectDrawerMaker {
    x = 0;
    quizObjects: Map<string, any>;
    sortedQuizObjects: Array<any>;
    pushQuizObject: Function;
    objectDrawer: React.ReactElement[] = [];
    subjectHashKey: string;
    cardIndex: number

    constructor(
        quizObjects: Map<string, any>,
        sortedQuizObjects: Array<any>,
        pushQuizObject: Function,
        subjectHashKey: string
    ) {
        this.quizObjects = quizObjects;
        this.sortedQuizObjects = sortedQuizObjects;
        this.pushQuizObject = pushQuizObject;
        this.subjectHashKey = subjectHashKey;
        this.cardIndex = 0;
    }

    iterateOverCardTables(cardTables: Array<any>) {
        cardTables.forEach((cardTable, index) => {
            this.genCardTableObjects(cardTable, index);
        });
    }
    
    incrementKey() {
        this.x++;
    }

    genCardTableObjects(cardTable: any, index: number) {
        this.objectDrawer.push(
            <ListSubheader
                classes={{ root: "sidebar-subheader-nested-1" }}
                component="div"
                id="nested-list-subheader"
                key={`subheader-${this.x}`}
            >
                {cardTable.name}
            </ListSubheader>
        );

        cardTable.cards.forEach((card: any, cardIndex: number) => {
            this.incrementKey();
            this.objectDrawer.push(
                <SidebarObjectListItem
                    classes="sidebar-list-item-nested-1"
                    subjectHashKey={this.subjectHashKey}
                    object={card}
                    key={this.x}
                />
            );
        });
    }

    genQuizObject(quizObject: any) {
        if (!quizObject) return;

        this.incrementKey();
        this.objectDrawer.push(
            <SidebarObjectSortableListItem
                // @ts-ignore - SortableElement HOC doesn't fully expose custom props in types
                object={quizObject}
                key={this.x}
                index={this.x}
                classes="sidebar-list-item-nested-1"
                subjectHashKey={this.subjectHashKey}
            />
        );
        this.pushQuizObject(quizObject._id);

        if (quizObject.card_tables.length > 0) {
            this.iterateOverCardTables(quizObject.card_tables);
        }
    }
    
    genSorted() {
        if (!this.sortedQuizObjects) return;

        this.sortedQuizObjects.forEach((quiz_object_id: string) => {
            let quizObject = this.quizObjects.get(quiz_object_id);
            this.genQuizObject(quizObject);
        });
    }

    genUnsorted() {
        if (!this.quizObjects) return;
        this.quizObjects.forEach((quizObject, index) => {
            /*
             * A quiz object may have already existed in the sorted list in which case, don't print it below
             */
            if (
                this.sortedQuizObjects &&
                this.sortedQuizObjects.includes(quizObject._id)
            )
                return;

            this.genQuizObject(quizObject);
        });
    }

    HTML() {
        return this.objectDrawer;
    }
}

export default ObjectDrawerMaker